//javasript entry point.
import nav from './components/c-navigation';
import mobileNav from './components/c-mobile-menu'; 
import bannerImage from './components/c-banner-image';
import signupModal from './components/c-modal';
import pulsar from './components/c-banner-pulser';
import FlexibleRow from './components/c-flexible-row';

import imageReveal from './animations/AnimationImageReveal';
import bannerAnimation from './animations/BannerAnimation';
import AnimationTitleReveal from './animations/TitleReveal';
import AnimationTextReveal from './animations/ContentReveal';
import NavigationReveal from './animations/NavigationReveal';
import jv from './components/JVFloat';
import NewsletterSignup from './components/c-newsletter';
import ObjectFit from './components/object-fit';

new nav('[data-component="c-navigation"]', document);
new mobileNav('[data-component="c-mobile-nav"]', document);
new pulsar('[data-component="c-banner-pulser"]', document);
new bannerImage('[data-component="c-banner-images"]', document);
new bannerAnimation('[data-animation="banner"]', document);
new AnimationTextReveal('*[data-animation="a-text-reveal"]', document);
new NavigationReveal('[data-animation="navigation"]', document);
new NewsletterSignup('[data-component="newsletter-signup"]', document); 
//new jv('.float-form-fields input[type="text"], .float-form-fields select, .float-form-fields textarea', document);
new signupModal('[data-component="signup-modal"]', document);

new imageReveal('[data-animation="image-reveal"]', document);
new AnimationTitleReveal('*[data-animation="a-title-reveal"]', document);
new FlexibleRow('[data-component="flexible-row"]', document);

if ('objectFit' in document.documentElement.style === false) {
    ObjectFit();
}

